module.exports = __webpack_public_path__ + "media/images/icon/icons8-iOS Photos-ec74070fcdc8d381bf6d2ed7df64f25b.png";